<template>
  <div class="col p-0">
    <div>
      <div class="d-flex mb-1">
        <h5>{{task.info.taskType | taskType}}</h5>
        <div class="ml-auto text-muted">
          <div v-if="isWorking">
            <small v-if="isBytes">{{progressCompleted | bytes}} / {{progressToComplete | bytes}}</small>
            <small v-else-if="isFiles">{{progressCompleted}} / {{progressToComplete}} files</small>
            <small v-else>{{progressCompleted}} / {{progressToComplete}} items</small>
          </div>
          <div v-else>
            <small>{{describeStatus}}</small>
          </div>
        </div>
      </div>
      <div>
        <b-progress :max="progressToComplete" class="mt-1">
          <b-progress-bar :animated="isWorking" :variant="progressVariant" :value="progressCompleted"></b-progress-bar>
        </b-progress>
      </div>

<!--      TODO: animated css toggle on status -->
<!--      <div v-if="isWaiting || isWorking">-->
<!--        <b-progress :max="progressToComplete" class="mt-1">-->
<!--          <b-progress-bar variant="success" :value="progressCompleted" animated></b-progress-bar>-->
<!--        </b-progress>-->
<!--      </div>-->
<!--      <div v-if="isPaused || isDone">-->
<!--        <b-progress :max="progressToComplete" class="mt-1">-->
<!--          <b-progress-bar variant="success" :value="progressCompleted"></b-progress-bar>-->
<!--        </b-progress>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>

import {
  TaskPhase, TaskProgress,
} from '#/protobuf/task_pb';
import { taskIsErrored, taskStatusDescription } from '#/models/jobs/task';

export default {
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // taskJson() {
    //   return JSON.stringify(this.task, null, 2);
    // },
    describeStatus() {
      return taskStatusDescription(this.task);
    },
    progressVariant() {
      if (this.isErrored) {
        return 'danger';
      }
      if (this.isCanceled) {
        return 'warning';
      }
      return 'success';
    },
    isBytes() {
      return this.task.info.taskProgress.progressUnit === TaskProgress.TaskProgressUnit.UNIT_BYTE_COUNT;
    },
    isFiles() {
      return this.task.info.taskProgress.progressUnit === TaskProgress.TaskProgressUnit.UNIT_FILE_COUNT;
    },
    isErrored() {
      return taskIsErrored(this.task);
    },
    isWaiting() {
      return this.task.info.taskPhase === TaskPhase.PHASE_WAITING || this.task.info.taskPhase === TaskPhase.PHASE_NONE;
    },
    isWorking() {
      return this.task.info.taskPhase === TaskPhase.PHASE_WORKING;
    },
    isPaused() {
      return this.task.info.taskPhase === TaskPhase.PHASE_PAUSED;
    },
    isDone() {
      return this.task.info.taskPhase === TaskPhase.PHASE_DONE;
    },
    isCanceled() {
      return this.task.info.taskPhase === TaskPhase.PHASE_CANCELED;
    },
    progressCompleted() {
      return this.task.info.taskProgress.progressCompleted;
    },
    progressToComplete() {
      return this.task.info.taskProgress.progressToComplete;
    },
  },
};
</script>

<style scoped>

</style>
